import { Route, RouteConfig } from 'vue-router';
import { getSuggestedServiceLevel } from '@api/investment-entity';
import { investmentEntity } from '@store/modules/investment-entity';
import { riaUpgrade } from '@store/modules/ria-upgrade';
import { RiaUpgradeRoute } from 'types/ria';
import { riaUpgradeRouteOrder } from '@src/constants';

const getFlowStepIndex = (name: RiaUpgradeRoute): number => {
	return riaUpgradeRouteOrder.indexOf(name) + 1;
};

const metaConstructor = (route: Route): object => ({
	step: getFlowStepIndex(route.name as RiaUpgradeRoute)
});

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const riaUpgradeRoutes: Array<RouteConfig> = [
	{
		path: `/account/ria-upgrade`,
		name: 'ria-upgrade',
		component: () => import(/* webpackChunkName: "ria-upgrade" */ '@views/account/ria-upgrade/ria-upgrade.vue'),
		beforeEnter: async (to, from, next) => {
			if (!investmentEntity.isReitInvestor || investmentEntity.currentRiaPlanName !== '') {
				next({ name: 'account-overview', replace: true });
			} else {
				next();
			}
		},
		redirect: { name: 'ria-upgrade-select-investment-plan' },
		children: [
			{
				path: 'select-investment-plan',
				name: 'ria-upgrade-select-investment-plan',
				meta: metaConstructor,
				beforeEnter: async (to, from, next) => {
					const suggestedServicePlan = await getSuggestedServiceLevel();
					riaUpgrade.UPDATE_SUGGESTED_SERVICE_LEVEL(suggestedServicePlan);

					const isStarterOrBasic =
						suggestedServicePlan.name === 'STARTER' || suggestedServicePlan.name === 'BASIC';
					if (isStarterOrBasic && !investmentEntity.isIraEntity) {
						const plan =
							suggestedServicePlan.name === 'STARTER'
								? await riaUpgrade.getStarterPlan()
								: await riaUpgrade.getBasicPlan();
						riaUpgrade.UPDATE_RIA_PLAN_ID(plan.id);
						next({ name: 'ria-upgrade-agreements', replace: true });
					} else {
						next();
					}
				},
				component: () =>
					import(
						/* webpackChunkName: "ria-upgrade-select-investment-plan" */ '@views/account/ria-upgrade/ria-upgrade-select-investment-plan.vue'
					)
			},
			{
				path: 'agreements',
				name: 'ria-upgrade-agreements',
				meta: metaConstructor,
				beforeEnter: async (to, from, next) => {
					if (!riaUpgrade.riaPlanId || !riaUpgrade.suggestedServiceLevel) {
						next({ name: 'ria-upgrade-select-investment-plan', replace: true });
					} else {
						next();
					}
				},
				component: () =>
					import(
						/* webpackChunkName: "ria-upgrade-agreements" */ '@views/account/ria-upgrade/ria-upgrade-agreements.vue'
					)
			},
			{
				path: 'success',
				name: 'ria-upgrade-success',
				meta: metaConstructor,
				beforeEnter: async (to, from, next) => {
					if (!riaUpgrade.hasSubmitted) {
						next({ name: 'ria-upgrade-select-investment-plan', replace: true });
					} else {
						next();
					}
				},
				component: () =>
					import(
						/* webpackChunkName: "ria-upgrade-success" */ '@views/account/ria-upgrade/ria-upgrade-success.vue'
					)
			}
		]
	}
];

export default riaUpgradeRoutes;
